//工单管理
const workOrderZh = {
  workOrderLang: {
    工单管理: '工单管理',
    新建工单: '新建工单',
    待分配: '待分配',
    待接单: '待接单',
    处理中: '处理中',
    已处理: '已处理',
    已完成: '已完成',
    已关闭: '已关闭',

    选择站点: '选择站点',
    工单类型: '工单类型',
    请选择: '请选择',
    全部: '全部',
    安装工单: '安装工单',
    维修工单: '维修工单',

    时间范围: '时间范围',
    开始日期: '开始日期',
    结束日期: '结束日期',
    开始月份: '开始月份',
    结束月份: '结束月份',
    开始年份: '开始年份',
    结束年份: '结束年份',

    请输入工单编号标题内容: '请输入工单编号、标题、内容',
    查询: '查询',
    重置: '重置',
    序号: '序号',
    工单编号: '工单编号',
    电站名称: '电站名称',
    紧急程度: '紧急程度',
    紧急: '紧急',
    一般: '一般',
    创建时间: '创建时间',
    工单标题: '工单标题',
    创建人: '创建人',
    操作: '操作',
    查看: '查看',
    编辑: '编辑',
    分配: '分配',
    关闭: '关闭',
    暂无数据: '暂无数据',
    分配工单: '分配工单',
    处理人: '处理人',
    请选择处理人: '请选择处理人',
    取消: '取消',
    确定: '确定',
    关闭工单: '关闭工单',
    关闭原因: '关闭原因',
    填写关闭原因: '填写关闭原因',
    分配工单成功: '分配工单成功',
    关闭工单成功: '关闭工单成功',

    编辑工单: '编辑工单',
    选择系统: '选择系统',
    处理方式: '处理方式',
    请输入: '请输入',
    工单详情: '工单详情',
    客户名称: '客户名称',
    客户联系人: '客户联系人',
    客户联系电话: '客户联系电话',
    客户地址: '客户地址',
    请选择工单类型: '请选择工单类型',
    请选择站点: '请选择站点',
    请输入工单标题: '请输入工单标题',
    工单标题必须少于50个字符: '工单标题必须少于50个字符',
    处理方式必须少于20个字符: '处理方式必须少于20个字符',
    客户名称必须少于20个字符: '客户名称必须少于20个字符',
    客户联系人必须少于20个字符: '客户联系人必须少于20个字符',
    客户地址必须少于50个字符: '客户地址必须少于50个字符',
    工单详情必须少于200个字符: '工单详情必须少于200个字符',
    联系电话必须少于20个字符: '联系电话必须少于20个字符',
    编辑成功: '编辑成功',
    新建成功: '新建成功',
    确认工单: '确认工单',
    查看工单: '查看工单',
    系统名称: '系统名称',
    返回: '返回',
    工单旅程: '工单旅程',
    分配至: '分配至',
    接单账号: '接单账号',
    上传图片: '上传图片',
    上传文件: '上传文件',
    处理描述: '处理描述',
    确认完成: '确认完成',
    接收工单: '接收工单',
    处理完成: '处理完成',
    处理进度更新: '处理进度更新',
    工单已确认处理完成: '工单已确认处理完成',

    选择站点: '选择站点',
    接单: '接单',
    是否确认接单: '是否确认接单？',
    提示: '提示',
    接单成功: '接单成功',
    分配时间: '分配时间',
    处理跟进: '处理跟进',
    处理结束: '处理结束',

    接单时间: '接单时间',
    处理结束时间: '处理结束时间',
    填写工单处理内容后点击确认即可结束处理此工单: '填写工单处理内容后，点击“确认”即可结束处理此工单。',
    填写内容后点击提交即可更新工单处理状态: '填写内容后，点击“提交”即可更新工单处理状态。',
    点击上传图片: '点击上传图片',
    上传的图片大小不得超过5M支持PNGJPG格式最多可上传5张图片: '上传的图片大小不得超过5M，支持PNG、JPG格式，最多可上传 5 张图片。',
    工单附件: '工单附件',
    点击上传附件: '点击上传附件',
    上传的附件只支持pdfdocdocxxlsxlsxtxt格式: '上传的附件只支持 pdf, doc, docx, xls, xlsx, txt格式。',
    处理描述必须少于100个字符: '处理描述必须少于100个字符',
    处理结束成功: '处理结束成功',
    失败: '失败 ',
    处理跟进成功: '处理跟进成功',
    图片大小不可超过5M: '图片大小不可超过5M',
    文件大小不可超过10M: '文件大小不可超过10M',
    最多5张图片当前总数已超过请重新选择: '最多5张图片,当前总数已超过,请重新选择！',
    最多5个附件当前总数已超过请重新选择: '最多5个附件，当前总数已超过，请重新选择',
    站点系统: '站点系统',
    完成时间: '完成时间',
    关闭时间: '关闭时间'
  }
}
export default workOrderZh
